import requestv2 from "~/utils/http-v2";

const utilitiesApi = {

	gets : async (params) => {
		const url = 'v2/utils';
		return await requestv2.get(url, {params});
	},

	notification : async (params) => {
		const url = 'v2/utils/notification';
		return await requestv2.get(url, {params});
	},

	ranks : async (params) => {
		const url = 'v2/utils/ranks';
		return await requestv2.get(url, {params});
	},

	checkDomain : async (domain) => {
		const url = `v2/utils/check-domain`;
		return await requestv2.post(url, {
			domain: domain
		});
	},

	whoisDomain : async (domain) => {
		const url = `v2/utils/whois-domain`;
		return await requestv2.post(url, {
			domain: domain
		});
	},
};

export default utilitiesApi;